import { createContext } from 'react';
import type { SegmentButtonPosition } from './SegmentButton/SegmentButton.types';

export const SegmentButtonContext = createContext<SegmentButtonPosition>({
  first: true,
  last: true,
});
